'use strict';

export const OPEN_ALERTS_SISP = 'alerts/OPEN_ALERTS_SISP';
export const CLOSE_ALERTS_SISP = 'alerts/CLOSE_ALERTS_SISP';
export const ALERTS_LOADING = 'alerts/ALERTS_LOADING';
export const ALERTS_LOADED = 'alerts/ALERTS_LOADED';
export const ALERTS_FAILED_TO_LOAD = 'alerts/ALERTS_FAILED_TO_LOAD';
export const VIEW_ALERT = 'alerts/VIEW_ALERT';
export const DISMISSING_ALERT = 'alerts/DISMISSING_ALERT';
export const ALERT_DISMISSED = 'alerts/ALERT_DISMISSED';